import { watch } from 'vue'
import { cloneDeep } from 'lodash'
import LGSdk from '@/packages/plugins/languageSDK/index'

/** 语言版本 */
export let LANGUAGE_TYPE_OPTIONS = LGSdk.getLGTypeList()
LGSdk.subscribeToConfig(() => {
  LANGUAGE_TYPE_OPTIONS = LGSdk.getLGTypeList()
})

/**
 * 矫正多语言数据, 保证每个语言都有对应的数据
 * @param {*} languages 多语配置数组
 * @param {*} defaultData 默认参数
 * @returns
 */
export const adjustLanguages = (languages, defaultData) => {
  return LANGUAGE_TYPE_OPTIONS.map((optionItem) => {
    const languageData = languages && Array.isArray(languages) ? languages.find((valItem) => valItem.language === optionItem.value) : null
    if (!languageData) {
      return Object.assign({ language: optionItem.value }, defaultData)
    } else {
      return Object.assign(cloneDeep(defaultData), languageData)
    }
  })
}

/**
 * 获取多语言默认数据数组
 * @param {*} languages 多语言列表
 * @param {*} data 数据
 * @returns
 */
export const getLanguagesDefaultDatas = (languages, data) => {
  const languagesData = []
  languages.forEach((item) => {
    const languageData = { language: item.value }
    languagesData.push(Object.assign(languageData, cloneDeep(data)))
  })
  return languagesData
}

export const initLanguagesData = (languages, language, data, defaultData) => {
  // 编辑器需实时监听样式变化
  if (import.meta.env.VITE_APP_TAG !== 'H5') {
    watch(
      () => languages,
      () => {
        data.value = initLanguagesData()
      },
      {
        deep: true
      }
    )

    watch(language, () => {
      data.value = initLanguagesData()
    })

    watch(
      defaultData,
      () => {
        data.value = initLanguagesData()
      },
      {
        deep: true
      }
    )
  }

  /**
   * 判断是否有多语言设置
   * @returns
   */
  const hasLanguages = () => {
    if (!languages.value || languages.value.length === 0) return false
    return languages.value.some((item) => {
      if (item.language === language.value) {
        const keys = Object.keys(item)
        // 检查除 'language' 外是否还有其他属性
        return keys.some((key) => key !== 'language' && item[key])
      } else if (item.language === 'en') {
        const keys = Object.keys(item)
        // 检查除 'language' 外是否还有其他属性
        return keys.some((key) => key !== 'language' && item[key])
      }
      return false
    })
  }

  /**
   * 设置多语言参数
   * @param {*} data
   */
  const initLanguagesData = () => {
    if (!hasLanguages()) return defaultData.value
    const newLanguageData = cloneDeep(defaultData.value)
    let enLanguageData = null
    const languageData =
      languages.value.find((item) => {
        if (item.language === 'en') enLanguageData = item
        return item.language === language.value
      }) || null
    if (languageData || enLanguageData) {
      // 有多语言配置字段
      const languageConfig = cloneDeep(languageData || enLanguageData)
      delete languageConfig.language
      Object.keys(languageConfig).forEach((key) => {
        if (
          (Array.isArray(languageConfig[key]) && languageConfig[key].length > 0) ||
          (!Array.isArray(languageConfig[key]) && typeof languageConfig[key] === 'object' && Object.keys(languageConfig[key]).length > 0) ||
          (typeof languageConfig[key] !== 'object' && languageConfig[key])
        ) {
          // 如果属性值是数组，且有值才合并
          // 如果属性值是对象，且有值才合并
          // 其他情况，有值才合并
          newLanguageData[key] = languageConfig[key]
        }
      })
    }
    return newLanguageData
  }

  return initLanguagesData()
}
